import createIcon from '../../createIcon';

/**
 * @component @name HdrAutoSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTZINi41VjIySDEwQzEwLjggMjIgMTEuNSAyMS4zIDExLjUgMjAuNVYxNy41QzExLjUgMTYuNyAxMC44IDE2IDEwIDE2Wk0xMCAyMC41SDhWMTcuNUgxMFYyMC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjUgMTZIMTNWMjJIMTQuNVYyMEgxNS42TDE2LjUgMjJIMThMMTcuMSAxOS45QzE3LjYgMTkuNiAxOCAxOS4xIDE4IDE4LjVWMTcuNUMxOCAxNi43IDE3LjMgMTYgMTYuNSAxNlpNMTYuNSAxOC41SDE0LjVWMTcuNUgxNi41VjE4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy41IDE4SDEuNVYxNkgwVjIySDEuNVYxOS41SDMuNVYyMkg1VjE2SDMuNVYxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMiAxOC41VjE2LjVIMjAuNVYxOC41SDE4LjVWMjBIMjAuNVYyMkgyMlYyMEgyNFYxOC41SDIyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjk3IDUuM0wxMC45NSA4LjE5SDEzLjA1TDEyLjAzIDUuM0gxMS45N1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAyQzguNjkgMiA2IDQuNjkgNiA4QzYgMTEuMzEgOC42OSAxNCAxMiAxNEMxNS4zMSAxNCAxOCAxMS4zMSAxOCA4QzE4IDQuNjkgMTUuMzEgMiAxMiAyWk0xNC4wNCAxMUwxMy40MSA5LjIxSDEwLjU4TDkuOTYgMTFIOC43NEwxMS4zNyA0SDEyLjYyTDE1LjI1IDExSDE0LjA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrAutoSelect = createIcon('HdrAutoSelect', [
  [
    'path',
    {
      d: 'M10 16H6.5V22H10C10.8 22 11.5 21.3 11.5 20.5V17.5C11.5 16.7 10.8 16 10 16ZM10 20.5H8V17.5H10V20.5Z',
      key: '1wuvpx',
    },
  ],
  [
    'path',
    {
      d: 'M16.5 16H13V22H14.5V20H15.6L16.5 22H18L17.1 19.9C17.6 19.6 18 19.1 18 18.5V17.5C18 16.7 17.3 16 16.5 16ZM16.5 18.5H14.5V17.5H16.5V18.5Z',
      key: '4zsb8d',
    },
  ],
  ['path', { d: 'M3.5 18H1.5V16H0V22H1.5V19.5H3.5V22H5V16H3.5V18Z', key: '1m2n03' }],
  ['path', { d: 'M22 18.5V16.5H20.5V18.5H18.5V20H20.5V22H22V20H24V18.5H22Z', key: '1v5x09' }],
  ['path', { d: 'M11.97 5.3L10.95 8.19H13.05L12.03 5.3H11.97Z', key: '1y9pti' }],
  [
    'path',
    {
      d: 'M12 2C8.69 2 6 4.69 6 8C6 11.31 8.69 14 12 14C15.31 14 18 11.31 18 8C18 4.69 15.31 2 12 2ZM14.04 11L13.41 9.21H10.58L9.96 11H8.74L11.37 4H12.62L15.25 11H14.04Z',
      key: 'jtssl1',
    },
  ],
]);

export default HdrAutoSelect;
